(() => {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main);
  } else {
    main();
  }

  function main() {
    addStyle();
    addDisclaimer();
  }

  function addStyle() {
    const style = document.createElement("style");
    style.textContent = `
      .cv-hero { display: none !important; }
      .cv-cta { margin-top: 1rem; background-color: #7a0001 !important; border-radius: 2px !important; }
    `;
    document.head.appendChild(style);
  }

  function addDisclaimer() {
    const disclaimer = document.createElement("p");
    disclaimer.innerHTML = `AI-generated visualisation is for illustrative purposes only. Product size, scale, placement, and dimensions may differ from the actual fit in your space. Please consult our customer service team or retail staff for accurate sizing and product recommendations.`;
    disclaimer.style.marginTop = `1rem`;
    disclaimer.style.fontSize = `10px`;
    disclaimer.style.textAlign = `justify`;

    document.querySelector(".cv-door")?.append(disclaimer);
  }
})()